import React, {useEffect, useState} from "react";

import userService from "../../services/user.service";
import {Navigate} from "react-router-dom";
import {useDispatch, useSelector} from "react-redux";
import DatePicker from "react-datepicker";
import {clearMessage} from "../../slices/message";
import monerisService from "../../services/moneris.service";
import ListItemDiscount from "../ListItemDiscount";
import ListItemNoDiscount from "../ListItemNoDiscount";

const SubscriptionsMoneris = () => {
  const getMinDate = () => {
    const today = new Date();
    const tomorrow = new Date(today);
    tomorrow.setDate(today.getDate() + 1);
    return tomorrow;
  };

  const [content, setContent] = useState("");
  const [loading, setLoading] = useState(false);
  const [responseCode, setResponseCode] = useState(400);
  const { user: currentUser } = useSelector((state) => state.auth);
  const [clientsSubs, setClientsSubs] = useState([]);
  const [subs, setSubs] = useState([]);
  const [message, setMessage] = useState(null);
  const [selectedDate, setSelectedDate] = useState(getMinDate());
  const [timeZone, setTimeZone] = useState("");
  const [clientWithDisc, setClientWithDisc] = useState([]);
  const [clientWithoutDisc, setClientWithoutDisc] = useState([]);
  const [taxInfo, setTaxInfo] = useState(undefined);
  const [displayDiscount, setDisplayDiscount] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);

  useEffect(() => {
    // Retrieve the client's timezone
    const clientTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    setTimeZone(clientTimezone);
  }, []);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(clearMessage());
  }, [dispatch]);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const [clientsRes, taxRes, subsRes, clientsSubsRes] = await Promise.all([
          userService.getClientList().catch(e => { console.error(e); return {data: []} }),
          userService.getTaxInfo().catch(e => { console.error(e); return {data: null} }),
          userService.getSubscription().catch(e => { console.error(e); return {data: []} }),
          userService.getClientsSubs().catch(e => { console.error(e); return {data: []} })
        ]);

        let cWithd = [];
        let cWithoutd = [];
        if (clientsRes.data && clientsRes.data instanceof Array) {
          setContent(clientsRes.data);
          clientsRes.data.forEach((c) => {
            if (c.subId && c.subDiscount > 0) {
              cWithd.push(c);
              setDisplayDiscount(true);
            } else {
              cWithoutd.push(c);
            }
          });
        }
        setClientWithoutDisc(cWithoutd);
        setClientWithDisc(cWithd);

        if (taxRes.data) {
          setTaxInfo(taxRes.data);
        }

        setSubs(subsRes.data);
        setClientsSubs(clientsSubsRes.data);

        setResponseCode(200);
      } catch (error) {
        console.error("Error loading initial data:", error);
        setContent(error.message || "Failed to load initial data");
        setResponseCode(400);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);


  if (!currentUser) {
    return <Navigate to="/login" />;
  }

    const handleDiscountItemSelect = (item) => {
        setSelectedItem(item);
    }

    const handleNoDiscountItemSelect = (item, sub) => {
        item.subPrice = sub.price;
        item.subDiscount = 0;
        item.subId = sub.id;
        setSelectedItem(item);
    }

  const refreshSubInfo = () => {
    setLoading(true);
    userService.getClientsSubs().then(
        (response) => {
          setClientsSubs(response.data);
          setResponseCode(200);
          setLoading(false);
        },
        (error) => {
          const _content =
              (error.response &&
                  error.response.data) ||
              error.message ||
              error.toString();
        console.log(error);

          setContent(_content);
          setResponseCode(error.response.status);
          setLoading(false);
        }
    );
  }

  const handleSubscribe = (client, startDate) => {
    console.log(client);
    setLoading(true);

    monerisService.preLoad([client.oid], client.subId, startDate, timeZone, true).then(
        (response) => {
          // console.log(response.data);
          setResponseCode(200);
          setLoading(false);
          localStorage.setItem("orderId", response.data);
          window.open("/checkout", "_blank");
        },
        (error) => {
          const _content =
              (error.response &&
                  error.response.data) ||
              error.message ||
              error.toString();
          console.log(error);

          setContent(_content);
          setResponseCode(error.response.status);
          setLoading(false);
        }
    );
  }

  return (
      <div className="container-fluid py-4" style={{ background: 'var(--bg-gradient)', minHeight: '100vh' }}>
        <div className="d-flex justify-content-between align-items-center mb-4">
          <h2>Subscriptions (Moneris)</h2>
        </div>

        {responseCode >= 400 && content && (
            <div className="alert alert-danger shadow-sm rounded-3 mb-4" role="alert">
                {(typeof content) === "string" ? content : (content.hasOwnProperty("message") ? content.message : "something wrong")}
            </div>
        )}

        {loading && (!clientWithDisc || clientWithDisc.length === 0) && (!clientWithoutDisc || clientWithoutDisc.length === 0) && (
            <div className="text-center py-5 mb-4 card border-0 shadow-lg rounded-4 bg-white">
                <div className="card-body py-5">
                    <div className="spinner-border text-primary" role="status" style={{ width: '3rem', height: '3rem' }}>
                        <span className="visually-hidden">Loading...</span>
                    </div>
                    <div className="mt-3 text-muted fw-bold">Loading subscription data...</div>
                </div>
            </div>
        )}

        {!loading && !((clientWithDisc && clientWithDisc.length > 0) || (clientWithoutDisc && clientWithoutDisc.length > 0)) && (
            <div className="card border-0 shadow-lg rounded-4 mb-4 bg-white">
                <div className="card-body text-center py-4 text-muted">
                    <i className="bi bi-info-circle fs-4 d-block mb-2"></i>
                    No eligible clients found for new subscriptions.
                </div>
            </div>
        )}

        {((clientWithDisc && clientWithDisc.length > 0) || (clientWithoutDisc && clientWithoutDisc.length > 0)) && (
            <div className="card border-0 shadow-lg rounded-4 mb-4">
                <div className="card-header bg-white p-4 border-bottom d-flex justify-content-between align-items-center">
                    <div className="d-flex align-items-center">
                        <span className="text-muted fw-bold me-3 text-nowrap">Start Date:</span>
                        <DatePicker
                            className="form-control"
                            selected={selectedDate}
                            onChange={date => setSelectedDate(date)}
                            minDate={getMinDate()}
                            popperPlacement="bottom-start"
                        />
                        {loading && <span className="spinner-border spinner-border-sm ms-3 text-primary"></span>}
                    </div>
                    {selectedItem && (
                        <button type="button" className="btn btn-primary rounded-pill px-4 shadow-sm" onClick={() => handleSubscribe(selectedItem, selectedDate)} disabled={loading}>
                            {loading ? (
                                <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                            ) : (
                                <i className="bi bi-credit-card me-2"></i>
                            )}
                            {loading ? "Subscribing..." : "Subscribe"}
                        </button>
                    )}
                </div>
                <div className="card-body p-0">
                    <div className="table-responsive">
                        <table className="table table-hover align-middle mb-0">
                            <thead className="table-light">
                                <tr>
                                    <th className="px-4 py-3">Client</th>
                                    <th className="py-3">Subscription</th>
                                    <th className="py-3">Price</th>
                                    <th className="py-3">Tax</th>
                                    {displayDiscount && <th className="py-3">Discount (%off)</th>}
                                </tr>
                            </thead>
                            <tbody>
                                {subs.length > 0 && clientWithDisc && clientWithDisc.length > 0 && (
                                    clientWithDisc.map((c, index) => (
                                        <ListItemDiscount key={c.oid} item={c} handleCheck={handleDiscountItemSelect} />
                                    ))
                                )}
                                {subs.length > 0 && clientWithoutDisc && clientWithoutDisc.length > 0 && (
                                    clientWithoutDisc.map((c, index) => (
                                        subs.map(sub => (
                                            <ListItemNoDiscount key={c.oid + sub.id} item={c} displayDiscount={displayDiscount} subscription={sub} handleCheck={handleNoDiscountItemSelect} />
                                        ))
                                    ))
                                )}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        )}

        <div className="card border-0 shadow-lg rounded-4 overflow-hidden">
            <div className="card-header bg-white p-4 border-bottom d-flex justify-content-between align-items-center flex-wrap gap-2">
                <h5 className="mb-0">Current Subscriptions</h5>
                <button type="button" className="btn btn-outline-primary rounded-pill px-3 shadow-sm" onClick={() => refreshSubInfo()} disabled={loading}>
                    {loading ? (
                        <span className="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
                    ) : (
                        <i className="bi bi-arrow-clockwise me-1"></i>
                    )}
                    {loading ? "Refreshing..." : "Refresh"}
                </button>
            </div>
            <div className="card-body p-0">
                <div className="table-responsive">
                    <table className="table table-hover align-middle mb-0">
                        <thead className="table-light">
                            <tr>
                                <th className="px-4 py-3">Client</th>
                                <th className="py-3">Subscription</th>
                                <th className="py-3">Start Date</th>
                                <th className="py-3">End Date</th>
                                <th className="py-3">Payment ID</th>
                            </tr>
                        </thead>
                        <tbody>
                            {clientsSubs && clientsSubs instanceof Array && clientsSubs.length > 0 ? clientsSubs.map((cs, index) => (
                                <tr key={index}>
                                    <th scope="row" className="px-4">{cs.clientName}</th>
                                    <td><span className="badge bg-info text-dark">{cs.subscriptionName}</span></td>
                                    <td>{cs.startDate}</td>
                                    <td>{cs.endDate}</td>
                                    <td><code className="text-muted">{cs.paymentId}</code></td>
                                </tr>
                            )) : (
                                <tr>
                                    <td colSpan="5" className="text-center py-4 text-muted">No subscriptions found</td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
      </div>
  );
};

export default SubscriptionsMoneris;
